// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2220c933","977":"628b582c"}[chunkId] + ".chunk.js";
};